import { Button, Card, Col, Flex, Form, message, Row } from "antd";
import CustomTextInput from "../components/CustomTextInput";
import useTitleStore from "../store/titleStore";
import { useEffect } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { authService } from "../services/auth.service";

export default function Profile() {
  const [messageApi, messageHolder] = message.useMessage();
  const [changePasswordForm] = Form.useForm();
  const [profileForm] = Form.useForm();
  const { setTitle } = useTitleStore();

  const { data: profileData } = useQuery({
    queryKey: ["profile"],
    queryFn: authService.fetchProfile,
  });

  useEffect(() => {
    if (profileData?.data) {
      profileForm.setFieldsValue({
        fullName: profileData.data.fullName,
        position: profileData.data.position ?? "-",
        directorate: profileData.data.directorate,
        phone: profileData.data.phone,
        email: profileData.data.email,
      });
    }
  }, [profileData, profileForm]);

  useEffect(() => {
    setTitle("Profile");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changePasswordMutation = useMutation({
    mutationFn: authService.changePassword,
    onSuccess: () => {
      messageApi.success("Password berhasil diubah");
      changePasswordForm.resetFields();
    },
    onError: (error) => {
      messageApi.error(
        error?.response?.data?.message || "Gagal mengubah password"
      );
    },
  });

  const handleChangePassword = (values) => {
    changePasswordMutation.mutate({
      email: profileData.data.email,
      fullName: profileData.data.fullName,
      phone: profileData.data.phone ?? "",
      password: values.password,
    });
  };

  const passwordRules = [
    { required: true, message: "Password wajib diisi" },
    { min: 8, message: "Minimal 8 karakter" },
    { pattern: /[A-Z]/, message: "Minimal 1 huruf besar" },
    { pattern: /[a-z]/, message: "Minimal 1 huruf kecil" },
    { pattern: /\d/, message: "Minimal 1 angka" },
    {
      pattern: /[!@#$%^&*(),.?":{}|<>]/,
      message: "Minimal 1 karakter spesial",
    },
  ];

  return (
    <>
      {messageHolder}
      <Card title="Profil">
        <Form form={profileForm} layout="vertical">
          <CustomTextInput
            label="Nama Lengkap"
            name="fullName"
            starLabel={false}
            inputProps={{ readOnly: true }}
          />

          <Row gutter={16}>
            <Col xs={24} md={12}>
              <CustomTextInput
                label="Jabatan"
                name="position"
                starLabel={false}
                inputProps={{ readOnly: true }}
              />
            </Col>
            <Col xs={24} md={12}>
              <CustomTextInput
                label="Direktorat"
                name="directorate"
                starLabel={false}
                inputProps={{ readOnly: true }}
              />
            </Col>
          </Row>

          <CustomTextInput
            label="Nomor Telepon"
            name="phone"
            starLabel={false}
            inputProps={{ readOnly: true }}
          />
          <CustomTextInput
            label="Email"
            name="email"
            starLabel={false}
            inputProps={{ readOnly: true }}
          />
        </Form>
      </Card>

      <Card
        style={{ marginTop: 24 }}
        styles={{
          body: {
            paddingLeft: 0,
            paddingRight: 0,
          },
        }}
        title={"Ubah Password"}
        actions={[
          <Flex style={{ padding: "0 24px" }}>
            <Button
              variant="solid"
              color="primary"
              loading={changePasswordMutation.isLoading}
              onClick={() => changePasswordForm.submit()}
            >
              Simpan
            </Button>
          </Flex>,
        ]}
      >
        <Form
          form={changePasswordForm}
          layout="vertical"
          onFinish={handleChangePassword}
          style={{ padding: "0 24px" }}
        >
          <Row gutter={16}>
            <Col span={24}>
              <CustomTextInput
                label="Password Baru"
                name="password"
                rules={passwordRules}
                inputProps={{ type: "password" }}
                password
              />
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
}
